import { Route, Routes } from "react-router-dom";
import List from "./list";
import Update from "./update";

function Router() {
  return (
    <Routes>
      <Route path="*" element={<List />} />
      <Route path=":id" element={<Update />} />
    </Routes>
  );
}

export default Router;
